import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import * as XLSX from "xlsx";
import saveAs from "file-saver";
import { Table, TableModule } from "primeng/table";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FormsModule } from "@angular/forms";
import { CommonModule, DatePipe } from "@angular/common";
// fixes/14757: AddTrackingSubmitDto is no longer exported by tracking-list.component (manual add-tracking dialog moved here)
import { TrackingListComponent } from "../tracking-list/tracking-list.component";
import { ClientSideLineTrackingListDto } from "../../../core/models/common/clientSideLineTrackingList.dto";
import { AddProjectWorkflowLineNotesDto } from "../../../core/models/project-workflow/addProjectWorkflowLineNotesDto";
import { AddWorkflowLineTrackingDto } from "../../../core/models/project-workflow/addWorkflowLineTrackingDto";
import { AddWorkflowTrackingRequestDto } from "../../../core/models/project-workflow/addWorkflowTrackingRequestDto";
import { DeleteWorkflowLineTrackingDto } from "../../../core/models/project-workflow/deleteWorkflowLineTracking";
import {
  WeightDto,
  DimensionDto,
} from "../../../core/models/project-workflow/dimensionDataDtos";
import { NonAddedSalesOrderLineDto } from "../../../core/models/project-workflow/getNonAddedProjectWorkflowLineDto";
import { ProjectWorkflowTrackingNumberDetailsDto } from "../../../core/models/project-workflow/GetProjectWorkflowTrackingDetailsDto";
import { ProductionWorkflowLineDto } from "../../../core/models/project-workflow/productionWorkflowLineDto";
import { ProductionWorkflowLineTrackingDto } from "../../../core/models/project-workflow/productionWorkflowLineTrackingDto";
import { ProjectWorkflowLineDto } from "../../../core/models/project-workflow/projectWorkflowLineDto";
import { TrackingDetailsBindingDto } from "../../../core/models/project-workflow/trackingDetailsBindingDto";
import { TrackingHistoryListDto } from "../../../core/models/project-workflow/trackingHistoryListDto";
import { UpdateManualTrackingStatusDto } from "../../../core/models/project-workflow/updateManualTrackingStatusRequestDto";
import { WorkflowNotificationSettings } from "../../../core/models/project-workflow/workflownotificationSettingDto";
import { WorkflowStatusDto } from "../../../core/models/project-workflow/workflowStatusDto";
import { LoaderService } from "../../../core/services/loader.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { SharedService } from "../../../core/services/shared.service";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import {
  FileUpload,
  FileUploadHandlerEvent,
  FileUploadModule,
} from "primeng/fileupload";
import { DialogModule } from "primeng/dialog";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { WorkflowLineNotesComponent } from "../workflow-line-notes/workflow-line-notes.component";
import { DatePickerModule } from "primeng/datepicker";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { ChartModule } from "primeng/chart";
import { TrackingListPopupComponent } from "../tracking-list-popup/tracking-list-popup.component";
import { TrackingDetailPopupComponent } from "../tracking-detail-popup/tracking-detail-popup.component";
import { AddWorkflowLinesComponent } from "../add-workflow-lines/add-workflow-lines.component";
import { NotificationSettingsComponent } from "../notification-settings/notification-settings.component";
import { AddTrackingComponent } from "../add-tracking/add-tracking.component";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { PopoverModule } from "primeng/popover";
import { CheckboxModule } from "primeng/checkbox";
import { TooltipModule } from "primeng/tooltip";

@UntilDestroy()
@Component({
  selector: "jni-workflow-line-items",
  templateUrl: "./workflow-line-items.component.html",
  styleUrls: ["./workflow-line-items.component.scss"],
  imports: [
    ButtonModule,
    CardModule,
    InputTextModule,
    CommonModule,
    FileUploadModule,
    DialogModule,
    SelectModule,
    WorkflowLineNotesComponent,
    FormsModule,
    TableModule,
    DatePickerModule,
    HidedynamicsdatePipe,
    PopoverModule,
    ChartModule,
    TrackingListPopupComponent,
    TrackingDetailPopupComponent,
    AddWorkflowLinesComponent,
    NotificationSettingsComponent,
    TrackingListComponent,
    AddTrackingComponent,
    SpinnerComponent,
    CheckboxModule,
    TooltipModule,
  ],
})
export class WorkflowLineItemsComponent implements DoCheck {
  @Input() orderLines = [] as ProductionWorkflowLineDto[];
  @Input() previousData = [] as ProductionWorkflowLineDto[];
  @Input() workflowId = 0;
  @Input() salesOrderIdD365 = "";
  @Input() smallLoader = false;
  @Input() statusList = [] as WorkflowStatusDto[];
  @Input() workflowStatus = 0;
  @Input() summaryPage = true;
  @Input() isDisableLink = false;
  @Output() downloadExcelTemplateEvent = new EventEmitter();
  @Output() refreshWorflowLineItemsEvent = new EventEmitter();
  @Output() refreshGridEvent = new EventEmitter();
  @Output() dropEvent = new EventEmitter<ProductionWorkflowLineDto[]>();
  @Output() showAllLinesEvent = new EventEmitter<boolean>();
  @Output() createProductionTaskEvent =
    new EventEmitter<ProductionWorkflowLineDto>();
  @Output() hasUnsavedChangesEvent = new EventEmitter<boolean>();
  selectedLineItem!: ProductionWorkflowLineDto[];
  workflowTrackingList = [] as ProductionWorkflowLineTrackingDto[];
  addTrackingModal = false;
  trackingListModal = false;
  trackingPopupAddMode = false;
  trackingLineQuantity = 0;
  trackingLineRecIdD365 = 0;
  trackingLineShippingMethod = "";
  trackingLineVendorSKU = "";
  trackingDetailsList = [] as ClientSideLineTrackingListDto[];
  trackingDetail = false;
  trackingHistoryModalOpen = false;
  trackingDetailsModalOpen = false;
  trackingHistoryList = [] as TrackingHistoryListDto[];
  historyTrackingNumber = "";
  historyShippingMethodName = "";
  historyEstDelivery = "";
  @ViewChild("fileUpload") fileUpload!: FileUpload;
  trackingNumberDetail = {} as ProjectWorkflowTrackingNumberDetailsDto;
  trackingWeight = [] as WeightDto[];
  trackingDimension = [] as DimensionDto[];
  addTrackingLineNumber = 0;
  addTrackingPurchaseOrder = "";
  isUPS = false;
  trackingDetailsBindingObj = {} as TrackingDetailsBindingDto;
  viewSettingsModal = false;
  notificationSettings = [] as WorkflowNotificationSettings[];
  trackingLineShippingMethodName = "";
  @ViewChild("dt") table!: Table;
  descriptionCharacterCond = false;
  showAllLinesFlag = false;
  notificationSettingLineRecId = 0;
  isDelivered = false;
  enabledStatus = 2;
  addWorkflowLinesModalDisplay = false;
  nonAddedLines = [] as NonAddedSalesOrderLineDto[];
  statusListMapping = [
    9, //PROJECTCREATED
    1, //ORDERWRITTEN
    2, //POSENT
    3, //PROOFSENT
    12, //REVISIONREQUESTED
    4, //PROOFAPPROVED
    5, //INPRODUCTION
    6, //SHIPPED
    7, //DELIVERED
  ];
  enabledStatusIndex = 2;
  currentStatus = 0;
  displaySidebarForNotes = false;
  notes = "";
  lineRecId = 0;
  shipDateCurrentdate = new Date();
  inHandDateCurrentdate = new Date();
  // fixes/14757: manual "Add Tracking" dialog fields replaced by the unified add-tracking popup (openAddTrackingFromList)
  // displayAddManualTrackingModal = false;
  // manualShippingMethods = [] as { code: string; shippingMethod: string }[];
  // trackings = "";
  // manualMethod = "";
  smallTrackingListLoader = false;
  @ViewChild("trackingList") trackingListPopup!: TrackingListComponent;
  isExcelUpload = false;
  disableAddTracking = false;
  popupmessage = "";
  dialogStatus = false;
  fedExStatusCategories: Record<string, string[]> = {
    Shipped: [
      "DO",
      "LC",
      "DS",
      "PD",
      "CA",
      "US",
      "RD",
      "IP",
      "HP",
      "RG",
      "RP",
      "RS",
    ],
    "In Transit": [
      "AR",
      "AF",
      "AC",
      "IT",
      "OX",
      "PM",
      "DP",
      "DR",
      "CP",
      "EA",
      "MD",
      "TR",
      "CC",
      "CH",
      "CD",
      "CP",
      "EA",
      "RR",
      "RM",
      "HA",
      "RT",
      "RA",
      "PR",
      "AS",
      "IN",
      "AE",
      "AO",
    ],
    Delivered: ["DL"],
    Exception: ["DD", "DE", "SE", "CD"],
    Delay: ["DY"],
    "Label Created": ["OC"],
    "Picked Up": ["PU"],
    "Out for Delivery": ["OD"],
  };

  constructor(
    private _toastr: JniToastrService,
    private _productionWorkflowService: ProjectWorkflowService,
    private _loaderService: LoaderService,
    private _sharedService: SharedService,
    public datePipe: DatePipe
  ) {}

  ngDoCheck() {
    if (this.orderLines.length > 0) {
      this.orderLines.forEach((item, index) => {
        const check = this._sharedService.deepCompare(
          item,
          this.previousData[index]
        );
        if (check) {
          this.hasUnsavedChangesEvent.emit(true);
        }
      });
    }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if(this.orderLines.length > 0){
  //     this.orderLines.forEach(line => {
  //       line.shipDateD365 = this.datePipe.transform(line.shipDateD365, 'MM-dd-yyyy');
  //       line.inHandDate = this.datePipe.transform(line.inHandDate,'MM-dd-yyyy');
  //     });
  //   }
  // }

  showUploadTracking = false;

  notificationList = ["BC", "BAC", "Admin", "Customer"];
  openedDropdownIndex: number | null = null;

  uploadTracking() {
    this.showUploadTracking = true;
  }

  closeUploadTracking() {
    this.fileUpload.clear();
    this.showUploadTracking = false;
  }

  closeModalDialog() {
    this.fileUpload.clear();
    this.showUploadTracking = false;
    this.trackingListModal = false;
    this.addTrackingModal = false;
    // fixes/14757: this.displayAddManualTrackingModal = false;
    this.trackingListPopup.cancelAllEditRow();
  }

  addTrackingData(
    event: {
      ShippingMethod: string;
      Quantity: number;
      VendorSKU: string;
      LineNumber: number;
      TrackingNumber: string;
      PurchaseOrder: string;
      IsMasterTracking: boolean;
      IsManualTracking?: boolean;
    }[],
    isManualTracking = false
  ) {
    this._loaderService.setLoaderState(true);
    this.showUploadTracking = false;
    if (event.length <= 0) {
      if (this.isExcelUpload) {
        this._toastr.error(
          "Error",
          "Selected Excel does not have any Trackings"
        );
      } else {
        this._toastr.error("Error", "Add a Tracking Number to Save Data");
      }
      this._loaderService.setLoaderState(false);
      this.fileUpload.clear();
      this.hasUnsavedChangesEvent.emit(false);
      return;
    }

    const shippedTracking = this.orderLines.find(
      item =>
        item.lineNumberD365 === event[0]?.LineNumber && //item.lineStatus === WorkflowStatusEnum.Shipped ||
        item.lineStatus === WorkflowStatusEnum.Delivered
    );
    if (shippedTracking) {
      this._toastr.error(
        "Error",
        `Unable to add since other trackings are already delivered.`
      );
      this._loaderService.setLoaderState(false);
      this.fileUpload.clear();
      this.hasUnsavedChangesEvent.emit(false);
      return;
    }

    const payload: AddWorkflowLineTrackingDto[] = event.reduce(
      (acc: AddWorkflowLineTrackingDto[], obj) => {
        const workflowItem = this.orderLines.find(
          item =>
            item.lineNumberD365 === obj.LineNumber &&
            item.externalItemNumberD365 === obj.VendorSKU &&
            item.purchaseOrderD365 === obj.PurchaseOrder &&
            item.isActive === true
        );

        if (workflowItem) {
          const tracking: AddWorkflowLineTrackingDto = {
            vendorSKU: workflowItem.externalItemNumberD365 ?? "",
            quantity: obj.Quantity ?? 0,
            trackingNumber: obj.TrackingNumber ?? "",
            lineRecIdD365: workflowItem.lineRecIdD365 ?? 0,
            workflowId: this.workflowId ?? 0,
            shippingMethodD365:
              obj.ShippingMethod && obj.ShippingMethod !== ""
                ? obj.ShippingMethod
                : (workflowItem.shippingMethodD365 ?? ""),
            salesOrderId: this.salesOrderIdD365 ?? "",
            lineNumberD365: workflowItem.lineNumberD365 ?? "",
            isMasterTracking: obj.IsMasterTracking ?? false,
            isManualTracking: obj.IsManualTracking ?? isManualTracking,
          };

          acc.push(tracking);
        }

        return acc;
      },
      [] as AddWorkflowLineTrackingDto[]
    );

    if (payload.length <= 0) {
      if (!this.isExcelUpload) {
        this._toastr.error(
          "Error",
          "Trackings added do not match with selected Line Item"
        );
      } else {
        this._toastr.error(
          "Error",
          "Excel data does not matches the Line Items, Kindly upload the correct Excel Sheet"
        );
      }
      this._loaderService.setLoaderState(false);
      this.fileUpload.clear();
      this.hasUnsavedChangesEvent.emit(false);
      return;
    }

    const request: AddWorkflowTrackingRequestDto = {
      processWorkflowTrackingDetailsRequestList: payload,
      isManualTracking: isManualTracking,
    } as AddWorkflowTrackingRequestDto;

    this._productionWorkflowService
      .postWorkflowLineTrackingList(request)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res && res.status === "Success") {
            this._toastr.success("Success", res.message);
            this.hasUnsavedChangesEvent.emit(false);
          } else {
            this._toastr.error("Error", res.message);
          }
          this.isExcelUpload = false;
          this.refreshWorflowLineItemsEvent.emit();
          this.refreshGridEvent.emit();
          this.closeModalDialog();
          return;
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message);
          this.closeModalDialog();
          return;
        },
      });
  }

  onUpload(event: FileUploadHandlerEvent) {
    this._loaderService.setLoaderState(true);
    const file = event.files[0];
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (e: ProgressEvent<FileReader>) => {
      /* create workbook */
      const binarystr: string = e.target?.result as string;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: "binary" });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const rows = XLSX.utils.sheet_to_json<string[]>(ws, { header: 1 });
      const headers = rows[0];

      const requiredHeaders = [
        "Quantity",
        "TrackingNumber",
        "LineNumber",
        "VendorSKU",
        "PurchaseOrder",
        "IsMasterTracking",
      ];
      const missingHeaders = requiredHeaders.filter(
        header => !headers.includes(header)
      );

      if (missingHeaders.length > 0) {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          "Error",
          `Missing requied columns: ${missingHeaders.join(", ")}`
        );
        return;
      }

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws).map((obj: unknown) => {
        const item = obj as {
          Quantity: number;
          VendorSKU: string;
          LineNumber: number;
          TrackingNumber: string;
          PurchaseOrder: string;
          IsMasterTracking: string | boolean;
        };
        return {
          Quantity: item.Quantity ?? 0,
          VendorSKU: String(item.VendorSKU),
          LineNumber: item.LineNumber ?? 0,
          TrackingNumber: String(item.TrackingNumber),
          PurchaseOrder: String(item.PurchaseOrder),
          IsMasterTracking: Boolean(item.IsMasterTracking ?? "false"),
          ShippingMethod: "",
        };
      }); // to get 2d array pass 2nd parameter as object {header: 1}
      this.isExcelUpload = true;
      this.addTrackingData(data);
    };
  }

  isDragOver = false;

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];

      // Validate file type
      if (
        !file.name.toLowerCase().endsWith(".xlsx") &&
        !file.name.toLowerCase().endsWith(".xls")
      ) {
        this._toastr.error(
          "File Upload Error",
          "Please select an Excel file (.xlsx or .xls)"
        );
        return;
      }

      // Validate file size (10MB limit)
      if (file.size > 10 * 1024 * 1024) {
        this._toastr.error(
          "File Upload Error",
          "File size must be less than 10MB"
        );
        return;
      }

      // Add the file to the PrimeNG FileUpload component
      if (this.fileUpload) {
        this.fileUpload.files = [file];
      }
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  }

  removeFile(file: File): void {
    const fileUpload = this.fileUpload;
    if (fileUpload) {
      const index = fileUpload.files?.indexOf(file);
      if (index !== undefined && index > -1) {
        fileUpload.files.splice(index, 1);
      }
    }
  }

  getWorkFlowTrackingExcelTemplate() {
    this._productionWorkflowService
      .getWorkFlowTrackingExcelTemplate()
      .subscribe({
        next: res => {
          //this._loaderService.setLoaderState(false);
          this.downloadFile(res);
        },
        error: res => {
          this._toastr.error("Error", res.message);
          //this._loaderService.setLoaderState(false);
        },
      });
  }

  downloadFile(data: Blob) {
    const file = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(file, `ProductionWorkflowTracking_Template.xlsx`);
  }

  showTrackingPopup(event: string) {
    this._loaderService.setLoaderState(true);
    if (!this.selectedLineItem || this.selectedLineItem?.length === 0) {
      this._toastr.error("Error", "Select a Line Item to Add Tracking Numbers");
      this._loaderService.setLoaderState(false);
      return;
    }

    if (this.selectedLineItem.length > 1) {
      this._toastr.error(
        "Error",
        "Select only one Line Item to Add Tracking Numbers"
      );
      this._loaderService.setLoaderState(false);
      return;
    }

    if (this.selectedLineItem && !this.selectedLineItem[0]?.isActive) {
      this._toastr.error("Error", "Cannot Add Tracking for Deleted Line Item");
      this._loaderService.setLoaderState(false);
      return;
    }

    const shippedTracking = this.orderLines.find(
      item =>
        item.lineNumberD365 === this.selectedLineItem[0]?.lineNumberD365 && //item.lineStatus === WorkflowStatusEnum.Shipped ||
        item.lineStatus === WorkflowStatusEnum.Delivered
    );
    if (shippedTracking) {
      this._toastr.error(
        "Error",
        `Unable to add since other trackings are already delivered.`
      );
      this._loaderService.setLoaderState(false);
      return;
    }

    this.trackingLineVendorSKU =
      this.selectedLineItem[0]?.externalItemNumberD365 ?? "";
    this.trackingLineQuantity = this.selectedLineItem[0]?.quantityD365 ?? 0;
    this.trackingLineRecIdD365 = this.selectedLineItem[0]?.lineRecIdD365 ?? 0;
    this.trackingLineShippingMethod =
      this.selectedLineItem[0]?.shippingMethodD365 ?? "";
    this.trackingLineShippingMethodName =
      this.selectedLineItem[0]?.shippingMethod ?? "";

    if (event === "add") {
      this.trackingPopupAddMode = true;
    } else {
      this.trackingPopupAddMode = false;
    }
    this.getWorflowLineTrackingList();
  }

  getWorflowLineTrackingList() {
    this.smallTrackingListLoader = true;
    this._productionWorkflowService
      .getWorkflowLineTrackingList(this.workflowId, this.trackingLineRecIdD365)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.workflowTrackingList = res.data;
            const shippedTracking = this.workflowTrackingList.find(
              item =>
                //item.deliveryStatus === "SHIPPED" ||
                item.deliveryStatus === "DELIVERED"
            );
            if (shippedTracking) {
              this.disableAddTracking = true;
            } else {
              const orderLine = this.orderLines?.find(
                line => line.lineRecIdD365 === this.trackingLineRecIdD365
              );
              if (
                orderLine && //orderLine.lineStatus === WorkflowStatusEnum.Shipped ||
                orderLine.lineStatus === WorkflowStatusEnum.Delivered
              ) {
                this.disableAddTracking = true;
              } else {
                this.disableAddTracking = false;
              }
            }

            if (this.trackingPopupAddMode) {
              this.addTrackingModal = true;
              this.trackingListModal = false;
              const orderLine = this.orderLines.find(
                x => x.lineRecIdD365 === this.trackingLineRecIdD365
              );
              this.addTrackingLineNumber = orderLine?.lineNumberD365 ?? 0;
              this.addTrackingPurchaseOrder =
                orderLine?.purchaseOrderD365 ?? "";
            } else {
              this.addTrackingModal = false;
              this.trackingListModal = true;
              this.trackingDetailsList = this.workflowTrackingList.map(obj => {
                const tracking = {} as ClientSideLineTrackingListDto;
                tracking.vendorSKU = obj.vendorSKU;
                tracking.quantity = obj.quantity;
                tracking.trackingNumber = obj.trackingNumber;
                tracking.deliveryStatus = obj.deliveryStatus;
                tracking.isFromDatabase = true;
                tracking.shippingMethod = obj.shippingMethod;
                tracking.id = obj.trackingLineId;
                tracking.lineRecIdD365 = this.trackingLineRecIdD365;
                tracking.shippingMethodName = obj.shippingMethodName;
                tracking.masterTrackingNumber = obj.masterTrackingNumber;
                tracking.isMasterTracking = obj.isMasterTracking;
                tracking.isManualTracking = obj.isManualTracking;
                if (obj.isManualTracking) {
                  tracking.deliveryStatusId = obj.deliveryStatusId ?? 0;
                } else {
                  tracking.deliveryStatusId = 0;
                }
                return tracking;
              });
              this.trackingDetailsList = this._sharedService.sortTrackingData(
                this.trackingDetailsList
              );
            }
          }
          this._loaderService.setLoaderState(false);
          this.smallTrackingListLoader = false;
        },
        error: res => {
          this._toastr.error("Error", res.message);
          this._loaderService.setLoaderState(false);
          this.smallTrackingListLoader = false;
        },
      });
  }

  deleteTrackingRecord(event: ClientSideLineTrackingListDto) {
    this._loaderService.setLoaderState(true);
    const payload = {} as DeleteWorkflowLineTrackingDto;
    payload.projectWorkflowTrackingLineId = event.id;
    this._productionWorkflowService
      .deleteWorkflowLineTracking(payload)
      .subscribe({
        next: res => {
          if (res?.data) {
            this.refreshWorflowLineItemsEvent.emit();
            this._toastr.success("Success", res.message);
          } else {
            this._toastr.error("Error", "Failed to Delete Record");
          }
          this._loaderService.setLoaderState(false);
        },
        error: res => {
          this._toastr.error("Error", res.message);
          this._loaderService.setLoaderState(false);
        },
      });
  }

  showTrackingDetailList(event: ProductionWorkflowLineDto) {
    this._loaderService.setLoaderState(true);

    this.trackingLineVendorSKU = event.externalItemNumberD365;
    this.trackingLineQuantity = event.quantityD365;
    this.trackingLineRecIdD365 = event.lineRecIdD365;
    this.trackingLineShippingMethod = event.shippingMethodD365 ?? "";
    this.trackingLineShippingMethodName = event.shippingMethod ?? "";
    this.trackingPopupAddMode = false;
    this.getWorflowLineTrackingList();
  }

  showTrackingHistory(event: ClientSideLineTrackingListDto) {
    this._productionWorkflowService
      .getTrackingHistoryByTrackingNumber(
        event.trackingNumber,
        this.trackingLineRecIdD365
      )
      .subscribe({
        next: res => {
          if (res?.data) {
            this.trackingHistoryList = res.data?.map(obj => {
              const mappedData = {} as TrackingHistoryListDto;
              mappedData.createdDate = obj.eventDate ?? "";
              mappedData.message =
                (obj.eventDescription ? obj.eventDescription + ", " : "") +
                (obj.address ? obj.address + ", " : "") +
                (obj.locationType ?? "");
              if (
                event.shippingMethod.includes("FX") &&
                obj.derivedStatusCode === obj.eventCode
              ) {
                mappedData.status =
                  Object.keys(this.fedExStatusCategories).find(category =>
                    this.fedExStatusCategories[category].includes(
                      obj.derivedStatusCode ?? ""
                    )
                  ) ??
                  obj.derivedStatus ??
                  "";
              } else {
                mappedData.status = obj.derivedStatus ?? "";
              }

              return mappedData;
            });
            this.historyTrackingNumber = event.trackingNumber;
            this.historyShippingMethodName = event.shippingMethodName;
            const historyOrderLine = this.orderLines.find(
              x => x.lineRecIdD365 === event.lineRecIdD365
            );
            this.historyEstDelivery = historyOrderLine?.inHandDate ?? "";
            this.trackingHistoryModalOpen = true;
          } else {
            this._toastr.error("Error", "Unable to get Tracking History");
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to get Tracking History");
        },
      });
  }

  closeModal() {
    this.addTrackingModal = false;
    this.trackingListModal = false;
    this.trackingListPopup.cancelAllEditRow();
  }

  openAddTrackingFromList() {
    const orderLine = this.orderLines.find(
      x => x.lineRecIdD365 === this.trackingLineRecIdD365
    );
    this.addTrackingLineNumber = orderLine?.lineNumberD365 ?? 0;
    this.addTrackingPurchaseOrder = orderLine?.purchaseOrderD365 ?? "";
    this.trackingListModal = false;
    this.addTrackingModal = true;
  }

  closeTrackingModals() {
    this.trackingHistoryModalOpen = false;
    this.trackingDetailsModalOpen = false;
  }

  showTrackingDetails(event: ClientSideLineTrackingListDto) {
    this.getTrackingDetails(event.trackingNumber);
  }

  viewTimelineFromShipmentDetails() {
    const event: ClientSideLineTrackingListDto = {
      id: 0,
      trackingNumber: this.trackingDetailsBindingObj.trackingNumber ?? "",
      quantity: this.trackingDetailsBindingObj.quantityD365 ?? 0,
      shippingMethod: this.trackingDetailsBindingObj.shippingMethod ?? "",
      vendorSKU: this.trackingDetailsBindingObj.vendorSkuD365 ?? "",
      deliveryStatus: this.trackingDetailsBindingObj.deliveryStatus ?? "",
      isFromDatabase: true,
      lineRecIdD365: this.trackingLineRecIdD365,
      shippingMethodName: this.trackingDetailsBindingObj.shippingMethod ?? "",
      isMasterTracking: false,
      isManualTracking: false,
      deliveryStatusId: 0,
    };
    this.trackingDetailsModalOpen = false;
    this.showTrackingHistory(event);
  }

  showLineNotifaction(index: number, event: Event) {
    event.preventDefault();
    this.openedDropdownIndex =
      this.openedDropdownIndex === index ? null : index;
  }

  getTrackingDetails(trackingNumber: string) {
    if (trackingNumber) {
      this._productionWorkflowService
        .getTrackingDetailsByTrackingNumber(
          trackingNumber,
          this.trackingLineRecIdD365
        )
        .subscribe({
          next: res => {
            if (res?.data) {
              this.trackingNumberDetail = res.data;
              if (
                res?.data.deliveryStatus?.toLowerCase() !== "pending" &&
                res?.data.deliveryStatus !== ""
              ) {
                if (res?.data?.weight && res?.data?.weight !== "") {
                  this.trackingWeight = JSON.parse(
                    res?.data?.weight ?? ""
                  ) as WeightDto[];
                }
                if (res?.data?.weight && res?.data?.dimension !== "") {
                  this.trackingDimension = JSON.parse(
                    res?.data?.dimension ?? ""
                  ) as DimensionDto[];
                }
              }
              this.mapTrackingNumberDetailData();
              if (this.trackingNumberDetail.shippingMethodD365?.match("UP")) {
                this.isUPS = true;
              }
              this.trackingDetailsModalOpen = true;
            } else {
              this._toastr.error("Error", "No Tracking details Found");
            }
          },
          error: res => {
            this._toastr.error("Error", res.message);
          },
        });
    }
  }

  mapTrackingNumberDetailData() {
    this.trackingDetailsBindingObj = {
      workFlowId: this.trackingNumberDetail.workFlowId ?? 0,
      actualDateTime: this.trackingNumberDetail.actualDateTime ?? "",
      address: this.trackingNumberDetail.address ?? "",
      shipperInformation:
        this.getStringWithComma(this.trackingNumberDetail.shipperCity ?? "") +
        this.getStringWithComma(
          this.trackingNumberDetail.shipperProvinceCode ?? ""
        ) +
        this.getStringWithComma(
          this.trackingNumberDetail.shipperCountryName ?? "",
          false
        ),
      recipientInformation:
        this.getStringWithComma(this.trackingNumberDetail.recipientCity ?? "") +
        this.getStringWithComma(
          this.trackingNumberDetail.recipientProvinceCode ?? ""
        ) +
        this.getStringWithComma(
          this.trackingNumberDetail.recipientCountryName ?? "",
          false
        ),
      vendorSkuD365: this.trackingNumberDetail.vendorSkuD365 ?? "",
      status: this.trackingNumberDetail.status ?? "",
      quantityD365: this.trackingNumberDetail.quantityD365 ?? 0,
      deliveryStatus: this.trackingNumberDetail.deliveryStatus ?? "",
      description: this.trackingNumberDetail.description ?? "",
      shippingMethodD365: this.trackingNumberDetail.shippingMethodD365,
      shippingMethod: this.trackingNumberDetail.shippingMethod,
      trackingNumber: this.trackingNumberDetail.trackingNumber,
    };

    const weightString = [] as string[];
    const dimesionString = [] as string[];
    this.trackingWeight.forEach(element => {
      if (this.isUPS) {
        weightString.push(
          (element.Weight ?? "") + " " + element.UnitOfMeasurement
        );
      } else {
        weightString.push((element.Value ?? "") + " " + element.Unit);
      }
    });
    this.trackingDimension.forEach(element => {
      const unitOfDimension = element.UnitOfDimension ?? "";
      const units = element.Units ?? "";
      if (this.isUPS) {
        dimesionString.push(
          "Length: " +
            (element.Length ?? 0) +
            " " +
            unitOfDimension +
            ", Width: " +
            (element.Width ?? 0) +
            " " +
            unitOfDimension +
            ", Height: " +
            (element.Height ?? 0) +
            " " +
            unitOfDimension
        );
      } else {
        dimesionString.push(
          "Length: " +
            (element.Length ?? 0) +
            " " +
            units +
            ", Width: " +
            (element.Width ?? 0) +
            " " +
            units +
            ", Height: " +
            (element.Height ?? 0) +
            " " +
            units
        );
      }
    });
    this.trackingDetailsBindingObj.weight = weightString;
    this.trackingDetailsBindingObj.dimension = dimesionString;
  }

  getStringWithComma(value: string | null, isCommaApplied = true) {
    return value && value !== "" ? value + (isCommaApplied ? ", " : "") : "";
  }

  getNotificationSettings(line: ProductionWorkflowLineDto) {
    this._loaderService.setLoaderState(true);
    this._productionWorkflowService
      .getWorkflowNotificationSettings(
        this.workflowId,
        false,
        line?.lineRecIdD365 ?? 0,
        true
      )
      .subscribe({
        next: res => {
          if (res?.data) {
            this.notificationSettings = res?.data;
            this.notificationSettingLineRecId = line?.lineRecIdD365 ?? 0;
            this.showOrHideNotificationSettings();
            this._loaderService.setLoaderState(false);
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to fetch notification settings");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  showOrHideNotificationSettings() {
    this.viewSettingsModal = !this.viewSettingsModal;
  }

  hideNotificationSettingDailog(event: boolean) {
    this.viewSettingsModal = event;
  }

  cancelAllEditRow() {
    this.table.value.forEach(x => {
      this.table.cancelRowEdit(x);
    });
  }

  editLine(id: number) {
    this.cancelAllEditRow();
    const row = this.table.value.filter(x => x.lineRecIdD365 === id);
    if (row.length > 0) {
      this.table.initRowEdit(row[0]);
    }
  }

  onRowEditSave(line: ProductionWorkflowLineDto) {
    this._loaderService.setLoaderState(true);

    if (line.shipDateD365 && line.inHandDate) {
      if (
        new Date(new Date(line.inHandDate).setHours(0, 0, 0, 0)) <
        new Date(new Date(line.shipDateD365).setHours(0, 0, 0, 0))
      ) {
        this._loaderService.setLoaderState(false);
        this.refreshWorflowLineItemsEvent.emit();
        this._toastr.error(
          "Error",
          "Ship date should be less than or equal to InHand date"
        );
        return;
      }
    }

    const payload: ProjectWorkflowLineDto = {
      projectWorkflowId: this.workflowId,
      lineRecId: line.lineRecIdD365,
      nickName: line.nickName ?? "",
      status: line.lineStatus,
      esd: line.shipDateD365,
      inHandDate: line.inHandDate,
      isFirmInHand: line.isFirmInHand,
    };

    this._productionWorkflowService
      .updateProjectWorkflowLines(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.cancelAllEditRow();
          if (res.status.toLowerCase() == "success") {
            this._toastr.success(
              "Success",
              res.message || "Line Item updated successfully"
            );
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error updating Line Item"
            );
          }
          this.refreshWorflowLineItemsEvent.emit();
          this.refreshGridEvent.emit();
          this.hasUnsavedChangesEvent.emit(false);
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error updating Line Item"
          );
          this.refreshWorflowLineItemsEvent.emit();
        },
      });
  }

  getOddEvenNumber(lineNumber: number) {
    if (lineNumber % 2 === 0) {
      return true;
    } else {
      return false;
    }
  }

  descriptionCharacterCount(obj: string) {
    if (obj && obj.length > 45) this.descriptionCharacterCond = true;
  }

  onDrop() {
    this.smallLoader = true;
    this.cancelAllEditRow();
    if (this.selectedLineItem?.length) {
      let lineNumbers = "";
      const filtered = this.selectedLineItem.filter(function (
        ele: ProductionWorkflowLineDto
      ) {
        if (
          ele.lineRecIdD365 !== undefined &&
          ele.lineRecIdD365 !== null &&
          ele.trackingCount <= 0
        ) {
          return true;
        } else {
          lineNumbers += ele.lineNumberD365 + " - " + ele.nickName + ", ";
          return false;
        }
      });
      if (filtered.length > 0 && lineNumbers.length <= 0) {
        this.showAllLinesFlag = false;
        this.dropEvent.emit(filtered);
        this.smallLoader = false;
      } else {
        this._toastr.error(
          "Error",
          `Selected Lines ${lineNumbers} cannot be deleted as they contain Tracking Numbers `
        );
        this.smallLoader = false;
        return;
      }
    } else {
      this._toastr.error("Error", "Select Lines for deletion");
      this.smallLoader = false;
      return;
    }
  }

  uncheckAll() {
    this.selectedLineItem = [];
  }

  toggleShowAllLines() {
    this.showAllLinesFlag = !this.showAllLinesFlag;

    if (this.showAllLinesFlag) {
      this.showAllLinesEvent.emit(true);
    } else {
      this.showAllLinesEvent.emit(false);
    }
  }

  getStatus(status: number) {
    if (this.statusList && status != null) {
      return this.statusList.find(x => x.id == status)?.status;
    }
    return "";
  }

  isStatusDisabled(status: number) {
    this.orderLines.every(line => line.lineStatus === status);
  }

  getNonAddedSalesOrderLines() {
    this.smallLoader = true;
    this._productionWorkflowService
      .getNonAddedSalesOrderLines(this.workflowId, this.salesOrderIdD365)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data && res?.data.length > 0) {
            this.nonAddedLines = res.data;
          } else {
            this.nonAddedLines = [];
          }
          this.addWorkflowLinesModalDisplay = true;
          this.smallLoader = false;
        },
        error: () => {
          this._toastr.error(
            "Error",
            "Attach a Sales Order to Import Line Items"
          );
          this.smallLoader = false;
        },
      });
  }

  addLinesToProjectWorkflow(event: number[]) {
    this.smallLoader = true;
    const request = {
      workflowId: this.workflowId,
      salesOrderId: this.salesOrderIdD365,
      lineRecIds: event,
    };
    this._productionWorkflowService
      .postAddLineToProjectWorkflow(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.addWorkflowLinesModalDisplay = false;
            this.refreshWorflowLineItemsEvent.emit();
            this.refreshGridEvent.emit();
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to add Lines to Project");
          this.smallLoader = false;
        },
      });
  }

  closeAddLineModal() {
    this.addWorkflowLinesModalDisplay = false;
  }

  showInputFieldForLineNote(lineRecId: number, notes: string) {
    this.notes = notes;
    this.lineRecId = lineRecId;
    this.displaySidebarForNotes = true;
  }

  closeSideBarForNotes() {
    this.displaySidebarForNotes = false;
  }

  saveNotes(request: AddProjectWorkflowLineNotesDto) {
    this._loaderService.setLoaderState(true);

    const payload: AddProjectWorkflowLineNotesDto = {
      projectWorkflowId: request.projectWorkflowId,
      lineRecId: request.lineRecId,
      notes: request.notes,
    };

    this._productionWorkflowService
      .addProjectWorkflowLineNotes(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status.toLowerCase() == "success") {
            this._toastr.success(
              "Success",
              res.message || "notes update successfully"
            );
            this.displaySidebarForNotes = false;
            this.refreshWorflowLineItemsEvent.emit();
          } else {
            this._toastr.error("Error", res.message || "Error updating notes");
          }
          this.refreshWorflowLineItemsEvent.emit();
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error updating notes");
          this.refreshWorflowLineItemsEvent.emit();
        },
      });
  }

  onShipDateSelection(event: Date, orderLine: ProductionWorkflowLineDto) {
    if (orderLine.shipDateD365 && orderLine.inHandDate) {
      if (
        new Date(new Date(orderLine.shipDateD365).setHours(0, 0, 0, 0)) >
        new Date(new Date(orderLine.inHandDate).setHours(0, 0, 0, 0))
      ) {
        this._toastr.error(
          "Error",
          "Ship date should be less than or equal to InHand date"
        );
        return;
      }
    }

    const date = new Date(event);
    orderLine.shipDateD365 = this.datePipe.transform(date, "MM-dd-yyyy") ?? "";
    if (orderLine.shipDateD365) {
      this.inHandDateCurrentdate = new Date(orderLine.shipDateD365);
    } else {
      this.inHandDateCurrentdate = new Date();
    }

    this.onRowEditSave(orderLine);
  }

  onInHandDateSelection(event: Date, orderLine: ProductionWorkflowLineDto) {
    if (orderLine.inHandDate && orderLine.shipDateD365) {
      if (
        new Date(new Date(orderLine.inHandDate).setHours(0, 0, 0, 0)) <
        new Date(new Date(orderLine.shipDateD365).setHours(0, 0, 0, 0))
      ) {
        this._toastr.error(
          "Error",
          "InHand date should be greater than or equal to Ship date"
        );
        return;
      }
    }

    const date = new Date(event);
    orderLine.inHandDate = this.datePipe.transform(date, "MM-dd-yyyy") ?? "";
  }

  onCalendarShow(orderLine: ProductionWorkflowLineDto) {
    // Wait for the calendar to be fully rendered, then insert the checkbox
    this.addFirmCheckbox(orderLine);

    // Add event listeners to detect when the calendar view changes
    const calendarPopup = document.querySelector(".p-datepicker");

    if (calendarPopup) {
      calendarPopup.addEventListener("click", event => {
        const target = event.target as HTMLElement;
        if (
          target.classList.contains("p-datepicker-next-icon") ||
          target.classList.contains("p-datepicker-prev-icon")
        ) {
          setTimeout(() => {
            this.addFirmCheckbox(orderLine);
          }, 1000);
        }
      });
    }
  }

  addFirmCheckbox(orderLine: ProductionWorkflowLineDto) {
    const calendarPopup = document.querySelector(
      ".p-datepicker .p-datepicker-group"
    );

    if (calendarPopup) {
      // Remove any existing checkbox to avoid duplicates
      const existingCheckbox = document.getElementById("calendar-checkbox");
      if (existingCheckbox) {
        existingCheckbox.parentElement?.remove();
      }

      const checkboxContainer = document.createElement("div");
      checkboxContainer.style.marginTop = "10px";
      checkboxContainer.style.textAlign = "left";

      checkboxContainer.innerHTML = `
        <label>
          <input type="checkbox" id="calendar-checkbox" ${orderLine.isFirmInHand ? "checked" : ""}>
          Firm
        </label>
      `;

      calendarPopup.appendChild(checkboxContainer);

      const checkboxElement = document.getElementById(
        "calendar-checkbox"
      ) as HTMLInputElement;

      checkboxElement.addEventListener("change", event => {
        orderLine.isFirmInHand = (event.target as HTMLInputElement).checked;
      });
    }
  }

  getLineStatusHighlight(status: number) {
    if (
      status === WorkflowStatusEnum.PoSent ||
      status === WorkflowStatusEnum.ProofSent ||
      status === WorkflowStatusEnum.RevisionRequested
    ) {
      return true;
    }
    return false;
  }

  getLineESDClass(line: ProductionWorkflowLineDto) {
    if (
      (line.lineStatus === WorkflowStatusEnum.ProofApproved ||
        line.lineStatus === WorkflowStatusEnum.InProduction) &&
      (!line.shipDateD365 || line.shipDateD365 === "")
    ) {
      return "warning";
    }

    if (line.shipDateD365 && line.shipDateD365 != "") {
      const shipDate = new Date(
        new Date(line.shipDateD365).setHours(0, 0, 0, 0)
      );
      const shippedDate = new Date(
        new Date(line.shippedDate ?? "").setHours(0, 0, 0, 0)
      );
      if (
        (shipDate < new Date(new Date().setHours(0, 0, 0, 0)) &&
          line.trackingCount == 0) ||
        shipDate < shippedDate
      ) {
        return "danger";
      }
    }

    return "";
  }

  getLineIHDClass(line: ProductionWorkflowLineDto) {
    const today = new Date().setHours(0, 0, 0, 0);
    const inHandDate = line.inHandDate
      ? new Date(line.inHandDate).setHours(0, 0, 0, 0)
      : null;
    const shipDate = line.shipDateD365
      ? new Date(line.shipDateD365).setHours(0, 0, 0, 0)
      : null;
    const deliveredDate = line.deliveryDate
      ? new Date(line.deliveryDate).setHours(0, 0, 0, 0)
      : today;
    if (
      line.isFirmInHand &&
      ((inHandDate && inHandDate < deliveredDate && line.trackingCount > 0) ||
        (inHandDate && inHandDate < deliveredDate) ||
        (shipDate && inHandDate && shipDate > inHandDate))
    ) {
      return "firm-danger";
    } else if (
      line.isFirmInHand ||
      (inHandDate && inHandDate < deliveredDate && line.trackingCount > 0) ||
      (inHandDate && inHandDate < deliveredDate) ||
      (shipDate && inHandDate && shipDate > inHandDate)
    ) {
      return "danger";
    } else if (
      line.shipDateD365 &&
      line.shipDateD365 != "" &&
      line.trackingCount !== 0 &&
      (!line.inHandDate || line.inHandDate === "")
    ) {
      return "warning";
    }
    return "";
  }

  getLineTrackingClass(line: ProductionWorkflowLineDto) {
    if (
      line.shipDateD365 &&
      line.shipDateD365 !== "" &&
      line.trackingCount === 0
    ) {
      return "warning";
    }
    return "";
  }

  // fixes/14757: replaced by openAddTrackingFromList() which opens the unified jni-add-tracking popup instead
  // getManualShippingMethods() {
  //   this._productionWorkflowService
  //     .getManualTrackingShippingMethods()
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: res => {
  //         if (res?.data) {
  //           this.manualShippingMethods = res?.data;
  //         } else {
  //           this.manualShippingMethods = [];
  //         }
  //         this.manualMethod = "";
  //         this.trackings = "";
  //         this.displayAddManualTrackingModal = true;
  //       },
  //     });
  // }

  // openAddManualTrackingModal() {
  //   this.manualMethod = "";
  //   this.trackings = "";
  //   this.getManualShippingMethods();
  // }

  // onTrackingListAddSubmit(event: AddTrackingSubmitDto) {
  //   if (!event.trackingNumber) {
  //     this._toastr.error("Error", "Enter Tracking Number");
  //     return;
  //   }

  //   this._loaderService.setLoaderState(true);

  //   const orderLine = this.orderLines.find(
  //     x => x.lineRecIdD365 === this.trackingLineRecIdD365
  //   );

  //   const trackingData = [
  //     {
  //       Quantity: event.quantity,
  //       VendorSKU: String(orderLine?.externalItemNumberD365),
  //       LineNumber: orderLine?.lineNumberD365 ?? 0,
  //       TrackingNumber: event.trackingNumber,
  //       PurchaseOrder: String(orderLine?.purchaseOrderD365),
  //       IsMasterTracking: event.isMasterTracking,
  //       ShippingMethod: event.shippingMethod,
  //     },
  //   ];
  //   this.addTrackingData(trackingData, event.trackingType === "other");
  // }

  // addManualTrackingNumbers() {
  //   if (this.trackings === "") {
  //     this._toastr.error("Error", "Enter Tracking Numbers");
  //     return;
  //   }

  //   if (this.manualMethod === "" || !this.manualMethod) {
  //     this._toastr.error("Error", "Select a Shipping Method");
  //     return;
  //   }

  //   this._loaderService.setLoaderState(true);
  //   const trackingNumbers = this.trackings.split(",");

  //   const orderLine = this.orderLines.find(
  //     x => x.lineRecIdD365 === this.trackingLineRecIdD365
  //   );

  //   const trackingData = trackingNumbers.map((obj: string) => {
  //     return {
  //       Quantity: 0,
  //       VendorSKU: String(orderLine?.externalItemNumberD365),
  //       LineNumber: orderLine?.lineNumberD365 ?? 0,
  //       TrackingNumber: String(obj),
  //       PurchaseOrder: String(orderLine?.purchaseOrderD365),
  //       IsMasterTracking: false,
  //       ShippingMethod: this.manualMethod,
  //     };
  //   });
  //   this.addTrackingData(trackingData, true);
  // }

  updateManualTrackingStatus(event: ClientSideLineTrackingListDto) {
    if (!event) {
      this._loaderService.setLoaderState(false);
      this._toastr.error("Error", "Invalid Request");
      return;
    }

    const request = {
      trackingLineId: event.id,
      trackingNumber: event.trackingNumber,
      status: event.deliveryStatusId ?? 0,
      lineRecId: event.lineRecIdD365,
      workflowId: this.workflowId,
      vendorSKU: event.vendorSKU ?? "",
    } as UpdateManualTrackingStatusDto;

    this._productionWorkflowService
      .updateManualTrackingStatus(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res?.data) {
            this._toastr.success(
              "Success",
              "Tracking Status updated Successfully"
            );
            this.getWorflowLineTrackingList();
          } else {
            this._toastr.error("Error", "Failed to update Tracking Status");
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed to update Tracking Status");
        },
      });
  }

  createProductionTask(lineItem: ProductionWorkflowLineDto) {
    if (lineItem) {
      this.createProductionTaskEvent.emit(lineItem);
    }
  }

  refreshGrid() {
    this.cancelAllEditRow();
    this.refreshWorflowLineItemsEvent.emit();
  }

  onInputChange(event: boolean) {
    this.hasUnsavedChangesEvent.emit(event);
  }

  onWorkflowListESDDateEdit(
    shipdate: string,
    orderLine: ProductionWorkflowLineDto
  ) {
    const date =
      shipdate !== null && shipdate !== "" ? new Date(shipdate) : new Date();
    orderLine.shipDateD365 = this.datePipe.transform(date, "MM-dd-yyyy") ?? "";
    this.hasUnsavedChangesEvent.emit(true);
  }

  onWorkflowLineStatusChange(
    event: SelectChangeEvent,
    orderline: ProductionWorkflowLineDto
  ) {
    orderline.lineStatus = event.value;
    this.onRowEditSave(orderline);
  }
}
